<template>
  <div class="popoverList">
    <div class="item" v-for="(item, index) in data.list" :key="index">
      <div>
        <img
          :src="require('@/assets/img/newUi-icon/' + item.img + '.png')"
          :alt="item.name"
          :width="item.width + 'px'"
          :height="item.height + 'px'"
        />
        <span class="title">{{ item.title }}</span>
        <span class="subTitle">{{ item.src }}</span>
      </div>

      <div>
        <p
          v-if="index == 1 || navindex == 1"
          class="btn btn1"
          @click="jump(1, 1, index)"
        >

          {{ $t("toeflTPO") }}
        </p>
        <p v-else class="btn btn1" @click="jump(1, 1, index)">
          {{ $t("TPO_In_Exam") }}
        </p>

        <p v-if="navindex == 1" class="btn btn2" @click="goUndisclosed">
          <img
            class="vipImg"
            src="../../../assets/img/newUi-icon/vip@2x.png"
            alt=""
          />
          {{ $t("Undisclosed") }}
        </p>
        <p
          class="btn btn1"
          v-if="index != 1 && navindex > 1 && navindex < 4"
          @click="jump(1, 2, index)"
        >
          {{ $t("TPO_Out_Exam") }}
        </p>
      </div>

      <div v-if="navindex != 1">
        <p v-if="index != 1" class="btn btn2" @click="jump(2, 1, index)">
          <img
            class="vipImg"
            src="../../../assets/img/newUi-icon/vip@2x.png"
            alt=""
          />
          {{ $t("Undis_In_Exam") }}
        </p>
        <p v-else class="btn btn2" @click="jump(2, 1, index)">
          <img
            class="vipImg"
            src="../../../assets/img/newUi-icon/vip@2x.png"
            alt=""
          />
          {{ $t(bottonText) }}
        </p>

        <p class="btn btn2" v-if="index != 1" @click="jump(2, 2, index)">
          <img
            class="vipImg"
            src="../../../assets/img/newUi-icon/vip@2x.png"
            alt=""
          />{{ $t("Undis_Out_Exam") }}  
        </p>
      </div>
    </div>
    <div class="bottom" v-if="data.bottom">
      <img
        src="@/assets/img/newUi-icon/free@2x.png"
        width="42px"
        height="20px"
        alt="free"
        v-if="navindex == 1 || navindex == 2"
      />
      <span>
        {{ data.bottom }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "headPopover",
  data() {
    return {
      isShow: true,
      toeflModel: {
        paperType: "tpo",
        tabIndex: 0,
      },
    };
  },
  props: {
    navindex: {
      type: Number,
      default: 0,
    },
    data: {
      type: Object,
      default: {},
    },
  },

  computed: {
    bottonText: function () {
      let txt = "";
      switch (this.navindex) {
        case 1:
          txt = "在考真题套题";
          break;
        case 2:
          txt = "ReadingZT";
          break;
        case 3:
          // txt = "听力真题";
          txt = "Undis_In_Exam";
          break;
        case 4:
          // txt = "口语真题";
          txt = "Undis_In_Exam";
          break;
        case 5:
          // txt = "写作真题";
          txt = "Undis_In_Exam";
          break;
      }
      return txt;
    },
  },

  methods: {
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },

    goUndisclosed() {
      if (this.$route.path != "/toefl/undisclosed/exam c") {
        this.$router.push({ path: "/toefl/undisclosed/exam" });
      }
    },
    jump(paperType, outType, index) {
      let pathName = "",
        basePath = "";
      switch (this.navindex) {
        case 1:
          pathName = "exam";
          break;
        case 2:
          pathName = "reading";
          break;
        case 3:
          pathName = "listening";
          break;
        case 4:
          pathName = "speaking";
          break;
        case 5:
          pathName = "writing";
          break;
      }
      if (paperType == 1) {
        basePath = "tpo";
      } else {
        basePath = "undisclosed";
      }
      if (this.navindex > 1) {
        if (paperType) this.toeflModel.paperType = paperType;
        //处理套题外的选项卡选中
        // if (this.toeflModel.outType == 2 && index == 2) {
        //   this.toeflModel.tabIndex = 1;
        // } else {
        this.toeflModel.outType = outType;
        this.toeflModel.tabIndex = index;
        // }
        this.$store.commit("toeflModel", this.toeflModel);
      }
      let path = `/toefl/${basePath}/${pathName}`;
      //判断path是否是当前路由
      if (this.$route.path == path) {
      } else {
        this.$router.push({ path: path });
      }
    },
  },
};
</script>
<style scoped>
.popoverList {
  /* min-height: 640px; */
}

.popoverList .item {
  overflow: hidden;
  padding-top: 24px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f2f5f5;
}

.popoverList .item img {
  display: inline-block;
}

.popoverList .item .title {
  margin-left: 8px;
  font-size: 16px;
  font-weight: 400;
  color: #384047;
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
}

.subTitle {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 13px;
  color: #999999;
  line-height: 26px;
  float: right;
  position: relative;
  bottom: 5px;
}

.btn {
  width: 150px;
  height: 35px;
  display: inline-block;
  /* text-align: center; */
  font-size: 14px;
  border-radius: 5px;
  line-height: 34px;
  margin-top: 3px;
  margin-left: 20px;
  cursor: pointer;
  background: #fff;
  color: #000;
}

.btn1{
  padding-left: 44px ;
}

.btn2{
  padding-left: 10px ;
  padding-right: 35px;
}

.btnGreem {
  background: #5fcf80;
  color: #fff;
}

.btnWite {
  background: #fff;
  color: #000;
}

.undisclosed {
  background: #fff;
  color: #000;
}

.btn:hover {
  background: #5fcf80;
  color: #fff;
}

.vipImg{
  /* float: left; */
}
.btn:hover .vipImg {
  content: url("../../../assets/img/newUi-icon/vip_bai@2x.png");
}

.btn img {
  width: 31px;
  height: 16px;
  position: relative;
  top: 2px;
}
.popoverList .bottom {
  width: 100%;
  height: 56px;
  background: #fff;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  /* position: absolute;
  bottom: 0;
  left: 0;
  right: 0; */
  padding-left: 19px;
  color: #28ac4f;
  line-height: 56px;
  font-size: 11px;
  display: inline-block;
}

.popoverList .bottom img {
  display: inline-block;
  position: relative;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/toefl/dialog/headPopover.vue